import CSRFactoryModel from './CSRFactoryModel';
  export default class CSRCountryModel {
    constructor(options) {
      this.data = options.data;
      this.factories = this.data.country_factories.map((obj) => new CSRFactoryModel({ data: obj }));
    }

    getFactoryModelForId(id) {
      let factory;
      for (let i = 0, leni = this.factories.length; i < leni; i++) {
        factory = this.factories[i];
        if (id === factory.getId()) {
          return factory;
        }
      }
      return false;
    }
  };

